/**
 * Botun insan gerektiren BEKLEME nedenleri ve sessiz giriş temposu (DEV-2603, DEV-3898).
 *
 * UYAP bağlantısı düşünce bot kimsenin başında olmadığı bir saatte (gece) kendi başına
 * yeniden girmeyi dener. Giremiyorsa nedeni kodla belirtir; imzacı bunu durum kartında
 * gösterir ve her bekleme bölümü için BİR işletim sistemi bildirimi + ses verir. Bekleme
 * sırasında e-imza girişi denenmez: yerel kapılar değerlendirilir; UYAP'a yalnız mevcut oturumu
 * devralma yoklaması gidebilir (hız sınırlı; olumsuz sonuç yeni bir tetikleyiciye kadar kalıcıdır:
 * DEVRALMA_YOKLAMA_ARALIK_MS ve store/index.ts oturumuDevralmayiDene).
 *
 * Saf tutuldu (store/DOM bağımlılığı yok) ki birim testten geçebilsin.
 */

import {PlayerDurum} from '@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes';

export type BotBeklemeSebebi =
    | 'PIN_GEREKLI'
    | 'PIN_KILITLI'
    | 'KART_YOK'
    | 'IMZA_PROGRAMI_KAPALI'
    | 'TCKN_EKSIK'
    | 'EICRAPRO_BEKLENIYOR'
    | 'UYAP_ERISILEMIYOR';

export interface BotBeklemeMetni {
    /** İşletim sistemi bildiriminin başlığı. */
    baslik: string;
    /** İşletim sistemi bildiriminin gövdesi. */
    bildirim: string;
    /** Durum kartındaki açıklama. */
    durum: string;
}

export const BOT_BEKLEME_METINLERI: Record<BotBeklemeSebebi, BotBeklemeMetni> = {
    PIN_GEREKLI: {
        baslik: 'Bot bekliyor: PIN gerekli',
        bildirim: 'Kartın PIN kodu kayıtlı değil. İmzacıda Bağlan’a basıp PIN’inizi girin.',
        durum: 'Bot bekliyor: bu kartın PIN kodu kayıtlı değil. Bağlan’a basıp PIN’inizi girin; bot kendiliğinden devam eder.'
    },
    PIN_KILITLI: {
        baslik: 'Bot bekliyor: e-imza PIN kodu kilitli',
        bildirim: 'E-imza kartınızın PIN kodu kilitlendi. Kilidi PUK koduyla açtıktan sonra imzacıda Bağlan’a basın.',
        durum: 'Bot bekliyor: e-imza kartının PIN kodu kilitli. Kartın kilidini, kartı aldığınız e-imza sağlayıcısının programında PUK koduyla açın; ardından Bağlan’a basıp PIN’inizi girin.'
    },
    KART_YOK: {
        baslik: 'Bot bekliyor: e-imza kartı yok',
        bildirim: 'Hesabınıza ait e-imza kartı takılı değil. Kartı takınca bağlantı kendiliğinden kurulur.',
        durum: 'Bot bekliyor: hesabınıza ait e-imza kartı takılı değil. Kartı takınca bağlantı kendiliğinden kurulur.'
    },
    IMZA_PROGRAMI_KAPALI: {
        baslik: 'Bot bekliyor: e-İmza programı kapalı',
        bildirim: 'e-İmza programı açık değil. Programı açın; bağlantı kendiliğinden kurulur.',
        durum: 'Bot bekliyor: e-İmza programı açık değil. Programı açın; bağlantı kendiliğinden kurulur.'
    },
    TCKN_EKSIK: {
        baslik: 'Bot bekliyor: TC kimlik numarası eksik',
        bildirim: 'e-imza sertifikasında TC kimlik numarası okunamadı. Kartınızı kontrol edin ya da destek ile iletişime geçin.',
        durum: 'Bot bekliyor: e-imza sertifikasında TC kimlik numarası okunamadı. Kartınızı kontrol edin ya da destek ile iletişime geçin.'
    },
    EICRAPRO_BEKLENIYOR: {
        baslik: 'Bot bekliyor: eİcraPro bağlantısı',
        bildirim: 'eİcraPro bağlantısı kesildi. Tarayıcıdan eİcraPro’ya yeniden giriş yapın.',
        durum: 'eİcraPro bağlantısı kesildi. Tarayıcıdan eİcraPro’ya yeniden giriş yapın; bot kendiliğinden devam eder.'
    },
    UYAP_ERISILEMIYOR: {
        baslik: 'Bot bekliyor: UYAP’a bağlanılamıyor',
        bildirim: 'UYAP’a bağlanılamıyor; bot aralıklarla yeniden deneyecek.',
        durum: 'UYAP’a bağlanılamıyor; bot aralıklarla yeniden deneyecek.'
    }
};

/** Plugin'in betaLogin hata kodunu ('kod' alanı) bekleme nedenine çevirir; insan gerektirmeyen kod null. */
export function kodtanSebebe(kod: unknown): BotBeklemeSebebi | null {
    if (kod === 'PIN_GEREKLI') return 'PIN_GEREKLI';
    if (kod === 'PIN_KILITLI') return 'PIN_KILITLI';
    if (kod === 'KART_YOK') return 'KART_YOK';
    if (kod === 'IMZA_PROGRAMI_KAPALI') return 'IMZA_PROGRAMI_KAPALI';
    if (kod === 'TCKN_EKSIK') return 'TCKN_EKSIK';
    return null;
}

/**
 * Sessiz girişlerin arası bekleme (ms): 30 sn, 1 dk, 2 dk, 5 dk (tavan). Otomatik
 * girişin geri çekilmesiyle AYNI dizi (store/index.ts bunu içe aktarır): iki yol aynı
 * sayaçları paylaşır.
 */
export const BOT_GIRIS_BEKLEMELERI_MS = [30000, 60000, 120000, 300000];

/**
 * Tarayıcı kaynaklı kurtarma isteğinde ('kurtarma') imzacının "bağlı" bayrağını canlı doğruladığı
 * oturum yoklamasının, GEÇERLİ çıkınca yeniden yapılmadığı süre (ms). Tarayıcı isteği 3/15/30 sn'de
 * bir yinelediği için UYAP'a yoklama yağmaz (store/index.ts tarayiciKurtarmasiniSurdur).
 */
export const KURTARMA_DOGRULAMA_ARALIK_MS = 10000;

/**
 * UYAP oturumu DEVRALMA yoklamasının (KullaniciBilgileri + kimlik kapısı) en sık yapılacağı aralık
 * (ms). İmzacının "bağlı" bayrağı düşükken (pencere yenilemesi, UYAP'ta hâlâ geçerli oturum) kart ve
 * PIN kapılarından ÖNCE bir kez yoklanır; geçerliyse oturum devralınır, e-imza ile YENİ giriş
 * gerekmez. Herhangi bir yoldan yapılan son oturum yoklamasından bu kadar süre geçmeden yenisi
 * atılmaz. Ayrıca OLUMSUZ yoklama (oturum yok ya da yabancı oturum) tetikleyiciye (kart takılması, yeni
 * kimlik, updateToken) kadar kalıcıdır: bot kart ya da PIN beklerken gece boyunca UYAP'a yoklama
 * yağmaz ve yabancı oturum için "başka hesap" diyaloğu yeniden doğmaz (store/index.ts
 * oturumuDevralmayiDene).
 */
export const DEVRALMA_YOKLAMA_ARALIK_MS = 120000;

/**
 * Durum kartı ve düğme ipucu "bot bekliyor" demeli mi: bekleme nedeni VAR ve bot ÇALIŞIYOR ('oto').
 * Durdur, 'Geç' ya da duraklatma sonrası bot durmuştur; "bot kendiliğinden devam eder" demek
 * yalan olur. PlayerDurum.oto sayısal 0'dır: karşılaştırma açık yapılır (falsy tuzağı).
 */
export function botBeklemeGorunurMu(sebep: BotBeklemeSebebi | null, player: PlayerDurum): boolean {
    return sebep !== null && Number(player) === PlayerDurum.oto;
}

/**
 * Bot durunca (player 'oto' dışına çıkınca) bekleme bölümü biter mi. Biter: sebep bota aittir ve bot
 * artık beklemiyor; sonraki engel yeni bölümdür (bildirim + ses). İstisna: aktif kimlik YOKKEN
 * TCKN_EKSIK lisans reddidir (kimlikten kaynaklanır, kullanıcının Durdur'una bağlı değil; durum
 * lisans düzelene kadar sürer). Kart sorunu olan TCKN_EKSIK yalnız aktif kimlik varken doğar.
 */
export function botBeklemeDurdurmadaSilinirMi(sebep: BotBeklemeSebebi | null, aktifKimlikVar: boolean): boolean {
    return sebep !== null && !(sebep === 'TCKN_EKSIK' && !aktifKimlikVar);
}

/**
 * Kartın bekleme açıklaması yerine ELLE bağlanma hatası gösterilmeli mi: kullanıcı Bağlan'a bastı
 * (sonElleDeneme > 0) ve durum mesajı bu denemeden sonra hata olarak yazıldıysa gerçek neden odur
 * (ör. giriş sonrası meta veri/kimlik denetimi hatası); bekleme metni yalnız bot kendi başına
 * beklerken yapılacak adımı söyler. İnsan gerektiren KODLU hatalarda (iptal/yanlış PIN: PIN_GEREKLI,
 * KART_YOK...) bekleme metni zaten yapılacak adımı söyler: kart bu durumda sonElleDeneme'yi 0'lar
 * (UyapStatusCard.handlePrimaryAction), yani bu fonksiyon false döner. Sessiz kodlu hatalar durum
 * mesajına hiç yazılmaz (connectToUyap).
 */
export function elleBaglanmaHatasiGosterilsinMi(
    mesaj: {type?: string, timestamp?: number} | null | undefined,
    sonElleDeneme: number
): boolean {
    return sonElleDeneme > 0 && !!mesaj && mesaj.type === 'error' &&
        typeof mesaj.timestamp === 'number' && mesaj.timestamp >= sonElleDeneme;
}

/** Bir saatte en çok bu kadar giriş DENEMESİ. */
export const BOT_SAATLIK_GIRIS_SINIRI = 6;

const SAAT_MS = 3600000;

export interface BotGirisKarari {
    izin: boolean;
    /** İzin yoksa denemenin açılmasına kalan süre (ms). */
    bekleMs: number;
    sebep?: 'geri-cekilme' | 'saatlik-sinir';
}

/**
 * Şimdi giriş denenebilir mi. Önce geri çekilme (son başarısızlıktan sonraki bekleme),
 * sonra saatlik sınır; 1 saatten eski kayıtlar sayılmaz. Saatlik sınırda bekleme, en eski
 * kaydın 1 saatinin dolmasına kadardır.
 */
export function botGirisiIzinVerilirMi(
    simdi: number,
    girisZamanlari: number[],
    sonrakiDenemeZamani: number
): BotGirisKarari {
    if (sonrakiDenemeZamani > simdi) {
        return {izin: false, bekleMs: sonrakiDenemeZamani - simdi, sebep: 'geri-cekilme'};
    }
    const yakin = girisZamanlari.filter((zaman) => simdi - zaman < SAAT_MS);
    if (yakin.length >= BOT_SAATLIK_GIRIS_SINIRI) {
        const enEski = Math.min(...yakin);
        return {izin: false, bekleMs: enEski + SAAT_MS - simdi, sebep: 'saatlik-sinir'};
    }
    return {izin: true, bekleMs: 0};
}
